export const STORE_TYPE = process.env.REACT_APP_STORE_TYPE || "default";
export const IS_BOOK_STORE = process.env.REACT_APP_STORE_TYPE === "book";
